export const getUxMode = () => {
  const defaultMode = "classic";

  try {
    const localValue = window.localStorage.getItem("uxMode");

    if (!localValue) return defaultMode;

    const parsedValue = JSON.parse(localValue) as string;

    return parsedValue;
  } catch (error) {
    console.error(
      `Unexpected failure occured while obtaining UX Mode from local storage, will use classic mode by default:`,
      error
    );
    return defaultMode;
  }
};

export const getAppPaths = () => {
  return {
    // root
    login: "login",
    // curate
    projects: "projects",
    upload: "upload",
    account: "account",
    // home
    home: "home",
    // ssdi
    ssdi: "datamanagement",
  };
};
